import { z } from 'zod';

import { useChannelSchema } from './channel-schema';
import { useJobDetailsSchema } from './job-details-schema';
import { usePoolSchema } from './pool-schema';

/**
 * Main hook for creating the complete validation schema for job posting form
 *
 * Combines:
 * - Channel validation (budgets, dates, allocations, budget type)
 * - Job details validation (title, description, stateCode when remote + ZipRecruiter)
 *
 * @param isZipRecruiterSelected - Passed from the form's parent so schema can validate stateCode without using context
 */
export function useValidationSchema(isZipRecruiterSelected = false) {
  return z.object({
    channels: useChannelSchema(),
    jobDetails: useJobDetailsSchema(isZipRecruiterSelected),
    pool: usePoolSchema().optional(),
  });
}
